var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_FINAL",
    "data-name": "Logo FINAL",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.1 112.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#33302e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "seat-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.3,42.55v14.2H368v-4c0-6.2,1-10.3,8.3-10.3h37Zm-39.8-8.8c-11.9,0-17.4,6.3-17.4,16.5v28.6H368V65.65h45.3v13.1h11.9v-45Zm66.4,0v8.8h28v36.2h11.9V42.55h28v-8.8ZM279.7,61.45c0,6.3,1.3,8.6,8.3,8.6h49.7v8.8H285.2c-11.9,0-17.5-5.4-17.5-15.5V33.75h69.9v8.8h-58v8.8h55.6V60H279.6v1.5Zm-85.2-12c-3.7-.3-4.3-1.6-4.3-3.8,0-2,1.1-3.2,3.9-3.2H249v-8.7H192.7c-8,0-13.5,3.1-13.5,12s4.1,12,13.3,12.8l44.5,3.7c3.4.3,4.4,1.4,4.4,3.9,0,2.3-1,3.8-4.1,3.8H181.4v8.8h56.8c9.8,0,14.1-3.9,14.1-13.1,0-8.4-3.9-11.8-13.4-12.6Z",
    transform: "translate(-7.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.9,40.85c.1-4.1.4-14,.6-19.8.3-7.5,1.8-12,4.9-14.8,4.3-3.8,9.2-4.7,21.1-5.3C62-.55,90-.35,125.1,2.15c3.7.3,5,.9,5.8,1.4,1.6,1.1,1.7,2.3,2.2,8.5.2,3.6.7,13.1,1,18.3-12.1-.6-32.6-1.7-50.5-1.9s-34,.1-35.9.4c-3.9.5-5.7,2.3-6.2,3.1l92.9,17.2v13.5Z",
    transform: "translate(-7.7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.8,47.45,134,71c-.1,3.4-.4,14.3-.6,20.6-.3,7.5-1.8,12-4.9,14.8-4.3,3.8-9.2,4.7-21.1,5.3-27.5,1.5-55.5,1.3-90.6-1.2-3.7-.3-5-.9-5.8-1.4-1.6-1.1-1.7-2.3-2.2-8.5-.3-4.2-.9-16.5-1.1-20.5C24,81.15,49,82,69.4,82c5.1,0,18.4.2,22,.2,2.8,0,6.5-.8,8.4-3.7l-92-15.8Z",
    transform: "translate(-7.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSeat);
export default __webpack_public_path__ + "static/media/logo_seat.56c9ddfeb41664470cc09f990e5a14f3.svg";
export { ForwardRef as ReactComponent };